import { Card, Text, Group, Button } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useCallback } from "react";
import useGetColaboradorById from "@/modules/colaboradores/hooks/useGetColaboradorById";
import useUserStore from "@/modules/users/store";
import { getCurrentUser } from "@/services/auth";
import { dataAutorizacoes } from "@/src/routes/empresa-page/EmpresaPage";
import JogadasDeInovacaoList from "../home-de-inovacao-list";
import useQueryJogadaDeInovacao from "../home-de-inovacao-list-modal/useQueryJogadaDeInovacao";

// prettier-ignore
const JogadasDeInovacaoHeader = () => {
  const { data, isLoading, refetch, isFetching } = useQueryJogadaDeInovacao();
  const activeEmpresaId = useUserStore((store) => store.activeEmpresa);
  const activeAutorizacao = useUserStore((store) => store.autorizacoes);
  const uid = getCurrentUser()?.uid;
  const { data: userColaborador } = useGetColaboradorById(activeEmpresaId?.id || "", uid || "");
  const autorizacao = dataAutorizacoes.find(item => item.label === userColaborador?.role);
  const formatAutorizacoes = activeAutorizacao?.filter(item => item.tipo === autorizacao?.value);
  /**
   * Função que trata o clique do botão.
   */
  const handleClickItem = useCallback(() => {
    modals.openContextModal({
      size: "xl",
      modal: "add-movimentacao-modal",
      innerProps: {
        refetch
      }
    });
  }, []);

  return (
    <>
      <Card withBorder style={{ overflow: "auto" }}>
        <Card.Section inheritPadding py="md" withBorder>
          <Group justify="space-between" style={{ marginBottom: 20 }}>
            <Text size="xl" fw={500}>
              Implementação das Jogadas de Inovação
            </Text>
            {formatAutorizacoes?.find(item => item.tipoAutorizacao === "19")?.criacao ?
              <Button variant="outline" radius="lg" size="md" onClick={handleClickItem}>
                <Text size="sm">Implementar nova jogada de inovação</Text>
              </Button>
              : <></>}
          </Group>
          <JogadasDeInovacaoList data={data} isLoading={isLoading} refetch={refetch} isFetching={isFetching} formatAutorizacoes={formatAutorizacoes} />
        </Card.Section>
      </Card>
    </>
  );
};

export default JogadasDeInovacaoHeader;
